module.exports = __webpack_public_path__ + "img/Lodging_and_Llamas-thumbnail.18f99975.jpg";